import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const BASE = "The Tech Savvy Company";
const SUFFIX = "Tech Help for Seniors and Beginners";

const META = {
  "/": {
    title: `${BASE} | ${SUFFIX}`,
    description:
      "Tech help for seniors and beginners in Columbus, Ohio. Friendly, patient, plain-English support for phones, computers, Wi-Fi, smart home and more. Call (380) 282-2525.",
  },
  "/services": {
    title: `Our Services | ${SUFFIX}`,
    description:
      "Tech help for seniors and beginners: new phone & computer setup, Wi-Fi, Ring & smart home installs, printers, email & password help, and one-on-one lessons in Columbus, OH.",
  },
  "/pricing": {
    title: `Pricing | ${SUFFIX}`,
    description:
      "Simple, honest pricing for tech help for seniors and beginners — Phone Setup $79, Wi-Fi Setup $99, Hourly Support $60/hr. No hidden fees, clear quote before we start.",
  },
  "/senior-tech-help": {
    title: `Senior Tech Help | ${BASE}`,
    description:
      "Patient, respectful tech help for seniors in Columbus, Ohio. We go at your pace, explain in plain English, and leave easy step-by-step notes. Call (380) 282-2525.",
  },
  "/about": {
    title: `About Us | ${SUFFIX}`,
    description:
      "Meet The Tech Savvy Company — friendly, local tech help for seniors and beginners in Columbus, Ohio, built on patience, honesty, and plain-English guidance.",
  },
  "/testimonials": {
    title: `Testimonials | ${BASE}`,
    description:
      "Read reviews from Columbus, Ohio families and seniors we've helped with phones, Wi-Fi, smart home devices, and one-on-one tech lessons.",
  },
  "/faq": {
    title: `FAQ | ${SUFFIX}`,
    description:
      "Answers to common questions about our friendly, patient tech help for seniors and beginners — in-home visits, pricing, devices we support, and more.",
  },
  "/glossary": {
    title: `Tech Glossary | Plain-English Tech Terms`,
    description:
      "A plain-English tech glossary for seniors and beginners. Look up common tech words like Wi-Fi, router, cloud, and password — with voice search and read-aloud.",
  },
  "/blog": {
    title: `Tech Tips & Guides | ${BASE}`,
    description:
      "Simple, friendly tech tips and how-to guides for seniors and beginners — written in plain English by The Tech Savvy Company in Columbus, Ohio.",
  },
  "/contact": {
    title: `Contact & Book | ${SUFFIX}`,
    description:
      "Book friendly, patient tech help for seniors and beginners in Columbus, Ohio. Call (380) 282-2525 or send a message — we usually reply the same day.",
  },
};

const DEFAULT = META["/"];

const setMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

export const SeoManager = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    let meta = META[pathname];
    if (!meta) {
      if (pathname.startsWith("/blog/")) meta = META["/blog"];
      else meta = DEFAULT;
    }
    document.title = meta.title;
    setMeta("name", "description", meta.description);
    setMeta("property", "og:title", meta.title);
    setMeta("property", "og:description", meta.description);
    setMeta("property", "og:url", `https://thetechsavvyco.com${pathname}`);
    setMeta("name", "twitter:title", meta.title);
    setMeta("name", "twitter:description", meta.description);

    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", `https://thetechsavvyco.com${pathname}`);
  }, [pathname]);

  return null;
};
